import type { AxiosResponse } from 'axios'

export class GeneralError extends Error {
  originalError: AxiosResponse | undefined

  constructor(originalError?: AxiosResponse, message?: string) {
    super(message || 'Something went wrong')
    this.originalError = originalError
  }
}
